import SmoothScroll from "smooth-scroll";
import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import AOS from "aos";
import MicroModal from "micromodal";

// スムーススクロール
var scroll = new SmoothScroll('a[href*="#"]', {
  speed: 500,
  speedAsDuration: true,
});

// conceptスライダー
conceptSlider();
function conceptSlider() {
  const splide = new Splide(".concept__slider", {
    type: "loop",
    arrows: false,
    arrows: false,
    pagination: false,
    gap: "1.6rem",
    fixedWidth: "80rem",
    padding: "32rem",
    drag: false,
    autoScroll: {
      speed: 1,
      pauseOnHover: false,
      rewindByDrag: false,
    },
    breakpoints: {
      880: {
        fixedWidth: "91.46%",
        padding: "0px",
        autoScroll: {
          speed: 0.7,
        },
      },
    },
  });

  splide.mount({ AutoScroll });
}

// aboutスライダー
aboutSlider();
function aboutSlider() {
  const dots = document.querySelector(".pagination__dots");
  const prevArrow = document.querySelector(".pagination__prev");
  const prevNext = document.querySelector(".pagination__next");
  const numberCurrent = document.querySelector(".number__current");
  const numberAll = document.querySelector(".number__all");

  const splide = new Splide(".about__slider", {
    type: "loop",
    arrows: false,
    pagination: false,
    gap: "2.4rem",
    width: "100%",
    breakpoints: {
      880: {
        width: "100%",
      },
    },
  });
  splide.mount();

  // li要素をスライダーの枚数分生成
  for (let i = 0; i < splide.length; i++) {
    let li = document.createElement("li");
    dots.appendChild(li);
  }

  // 生成したli要素を取得
  const liElm = document.querySelectorAll(".pagination__dots li");
  liElm[0].classList.add("is-active");

  // number要素の初期値を設定
  let currentIndex = splide.index + 1;
  const allIndex = splide.length;
  //数値を文字列に変換し、２文字以下だった場合 先頭に0を追加
  numberCurrent.textContent = currentIndex.toString().padStart(2, "0");
  numberAll.textContent = allIndex.toString().padStart(2, "0");

  // スライダーが移動したとき
  splide.on("move", function () {
    currentIndex = splide.index + 1;

    liElm.forEach((e, i) => {
      e.classList.remove("is-active");
      liElm[splide.index].classList.add("is-active");

      // li要素をクリックしたとき
      e.addEventListener("click", function () {
        e.classList.remove("is-active");
        liElm[i].classList.add("is-active");
        splide.go(i);
      });
    });

    // numberCurrent要素の値を更新
    numberCurrent.textContent = currentIndex.toString().padStart(2, "0");
  });

  // 戻る矢印イベント
  prevArrow.addEventListener("click", function () {
    splide.go("<");
  });

  // 次へ矢印イベント
  prevNext.addEventListener("click", function () {
    splide.go(">");
  });
}

// reserveセクションのコンテンツ切り替え
reserveContentChange();
function reserveContentChange() {
  const reserveTabs = document.querySelectorAll(".reserve__tab a");
  const removeContent = document.querySelectorAll(".reserve__main");

  reserveTabs[0].addEventListener("click", function () {
    reserveTabs[0].classList.add("is-active");
    reserveTabs[1].classList.remove("is-active");
    removeContent[0].classList.remove("is-hide");
    removeContent[1].classList.add("is-hide");
  });

  reserveTabs[1].addEventListener("click", function () {
    reserveTabs[0].classList.remove("is-active");
    reserveTabs[1].classList.add("is-active");
    removeContent[0].classList.add("is-hide");
    removeContent[1].classList.remove("is-hide");
  });
}

// AOSアニメーション
aosAnimation();
function aosAnimation() {
  AOS.init({
    anchorPlacement: "bottom-center",
    duration: 600,
    easing: "ease-out-cubic",
    once: true,
  });
}

// モーダルウィンドウ
modalWindow();
function modalWindow() {
  MicroModal.init({
    disableScroll: true,
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,
  });

  const modalOverlay = document.querySelector("#modal-layer .modal__overlay");

  modalOverlay.addEventListener("click", (event) => {
    if(event.target === modalOverlay){
      MicroModal.close("modal-layer");
    }
  });
}
